import React from 'react';
import { useSelector } from 'react-redux';
import { selectSprayEventTypeIsCrop } from 'services/sprayEventType/selectors';

export interface OwnProps {
    children: React.ReactElement;
    fallback?: React.ReactElement;
}

type Props = OwnProps;

export default function SprayEventTypeCropGate(
    props: Props
): React.ReactElement | null {
    const { children, fallback } = props;

    const isSprayEventTypeCrop = useSelector(selectSprayEventTypeIsCrop);

    if (!isSprayEventTypeCrop) {
        if (fallback) {
            return fallback;
        }

        return null;
    }

    return children;
}
